import axios from 'axios';
import { GetRecommendationResponseType } from '../types/company.type';
import { DividendHistoryResponse } from '../types/dividendhistory.type';

import { apiBase } from './apiBase';
export const getRecommendationData = (
  region: string,
  rcmd: string,
  page: number,
  size: number,
  token: string,
): Promise<GetRecommendationResponseType> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/recommendation/`,
        {
          params: {
            region: region,
            page: page,
            size: size,
            token: token,
            rcmd: rcmd,
          },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined as any);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOwnership = (symbol: string, token: string): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/ownership/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data.data) {
          resolve(res.data.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCompanyProfile = (
  symbol: string,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/profile/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data.data) {
          resolve(res.data.data);
        } else resolve(undefined);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSectorPeerCompare = (
  region: string,
  sector: string,
  tab: string,
  sortcol: string,
  sortord: string,
  page: number,
  size: number,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/peercompare/`,
        {
          params: {
            region: region,
            sector: sector,
            tab: tab,
            sortcol: sortcol,
            sortord: sortord,
            page: page,
            size: size,
            token: token,
          },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getStockPeerCompare = (
  region: string,
  symbol: string,
  tab: string,
  sortcol: string,
  sortord: string,
  page: number,
  size: number,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/peercompare/`,
        {
          params: {
            region: region,
            symbol: symbol,
            tab: tab,
            sortcol: sortcol,
            sortord: sortord,
            page: page,
            size: size,
            token: token,
          },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getIndicesPeerCompare = (
  region: string,
  index: string,
  tab: string,
  sortcol: string,
  sortord: string,
  page: number,
  size: number,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/peercompare/`,
        {
          params: {
            region: region,
            index: index,
            tab: tab,
            sortcol: sortcol,
            sortord: sortord,
            page: page,
            size: size,
            token: token,
          },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getComapnyScore = (
  symbol: string,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/score/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTargetPrice = (symbol: string, token: string): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/targetprice/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBrokerRating = (
  symbol: string,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/brokerrating/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getIncomeStatement = (
  symbol: string,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/incomestatement/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBalanceSheet = (
  symbol: string,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/balancesheet/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCashFlow = (symbol: string, token: string): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/cashflow/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getKeyRatios = (symbol: string, token: string): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/keyratios/`,
        {
          params: { symbol: symbol, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMinichartPeerCompare = (
  region: string,
  rics: string,
  sector_peers: boolean,
  count: number,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    const params: any = {
      region: region,
      tab: 'narrow',
      sortcol: 'mktcap',
      sortord: 'desc',
      page: 1,
      size: count,
      token: token,
      rics: rics,
      sector_peers: sector_peers,
    };

    axios
      .get(
        `${apiBase()}/company/peercompare/`,
        {
          params: params,
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMinichartSearch = (
  region: string,
  rics: string,
  token: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/search/minichart`,
        {
          params: { rics: rics, region: region, token: token },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getCompanyEventData = (
  ric: string,
  eventType: string,
  token: string,
  pageNum: number,
  pageSize: number,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/event`,
        {
          params: { ric, eventType, token, pageNum, pageSize },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCompanyDirectorData = (
  ric: string,
  token: string,
  sortBy: string,
  orderBy: string,
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/director`,
        {
          params: { ric, token, sortBy, orderBy },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDividendHistroyData = ({
  token,
  ric,
}: {
  token: string;
  ric: string;
}): Promise<DividendHistoryResponse | undefined> => {
  return new Promise(async (resolve, reject) => {
    axios
      .get(
        `${apiBase()}/company/dividend/history`,
        {
          params: { token, ric },
        },
      )
      .then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
